import { useEffect, useRef, useState } from 'react';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/** Płynne dojście do wartości docelowej (ease-out). Przy `prefers-reduced-motion` skok bez animacji. */
export function useCountUp(target: number | null, durationMs = 700): number | null {
  const [shown, setShown] = useState<number | null>(target);
  const from = useRef<number>(0);

  useEffect(() => {
    if (target === null || !Number.isFinite(target)) {
      setShown(null);
      return;
    }
    if (prefersReducedMotion() || durationMs <= 0) {
      from.current = target;
      setShown(target);
      return;
    }
    const start = performance.now();
    const origin = from.current;
    let raf = 0;
    const tick = (now: number) => {
      const p = Math.min(1, (now - start) / durationMs);
      const eased = 1 - Math.pow(1 - p, 3);
      const v = origin + (target - origin) * eased;
      from.current = v;
      setShown(v);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, durationMs]);

  return shown;
}
